import React from 'react';
import { createIcon } from 'components/shared/SVGIcon';

const LogOutIcon = createIcon(
  'LogOut',
  <path d="M11,3 C11.55,3 12,3.45 12,4 L11.9932398,4.11619898 C11.9352041,4.6119898 11.5107143,5 11,5 L5,5 L5,19 L11,19 C11.55,19 12,19.45 12,20 L11.9932398,20.116199 C11.9352041,20.6119898 11.5107143,21 11,21 L5,21 C3.9,21 3,20.1 3,19 L3,5 C3,3.9 3.9,3 5,3 Z M17,9.21 C17,8.76 17.54,8.54 17.86,8.86 L20.65,11.65 C20.84,11.84 20.84,12.16 20.64,12.35 L17.85,15.14 C17.54,15.46 17,15.24 17,14.79 L17,13 L10,13 C9.45,13 9,12.55 9,12 L9.0067602,11.883801 C9.06479592,11.3880102 9.48928571,11 10,11 L17,11 Z" />
);

export default LogOutIcon;
